var React =        require("react");

var Utility =      require("../../util/Utilities.js");

class ElementPreview extends React.Component {

    constructor(){
        super();
    }

    getIcon(type){
        switch(type){
            case "component":
                return  <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><use xlinkHref='#component' className="icon" /></svg>
            case "symbol":
                return  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><use xlinkHref='#symbol' className="icon" /></svg>
            case "package":
                return  <svg width="25" height="20" xmlns="http://www.w3.org/2000/svg"><use xlinkHref='#package' className="icon" /></svg>
            default:
                return  <svg width="18" height="20" xmlns="http://www.w3.org/2000/svg"><use xlinkHref='#fooprint' className="icon" /></svg>
        }
    }

    render() {
        let {id, name, user_name, summary, type, version, updated_at, useIn, contains, 
            explicit = false, idSelected, hasModel3d } = this.props;

        summary = Utility.formatDescription(summary) || "No summary";
        updated_at = Utility.formatDateMonthString(updated_at);

        let isSelected = idSelected === id ? "selected": "";

        let className = explicit ? "elementPreview explicit": "elementPreview";

        return  <div className={`${className} ${isSelected}`} onClick={() => this.props.showItem({id, type})}>
                    <div className="elementPreview__icon"> {this.getIcon(type)} </div>
                    <div className="elementPreview__name"> {name} </div>
                    <div dangerouslySetInnerHTML={{__html: summary}}></div>
                    <div className="elementPreview__version"> {version} </div>
                    <div> {updated_at} </div>
                    {type === "package" && hasModel3d === "BoxData" &&
                        <React.Fragment>
                            <div className="elementPreview__warning">
                                <svg width="23" height="23" xmlns="http://www.w3.org/2000/svg">
                                    <use xlinkHref='#warning' className="warning"/>
                                </svg>
                                <div className="elementPreview__warning__info">Missing 3D Model</div>
                            </div>
                        </React.Fragment>
                    }
                </div>
    }
};

module.exports = ElementPreview;
